/**
 * @generated SignedSource<<c6d3f558def6f67b9af007a62a951778>>
 * @relayHash 624bb7f2e1333a1dc93bb4e3e1ab1a47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50cdeb2f8746825d9a317b38ba0c85a01e96c5247af9f0eb632d2a708fb4be48

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$variables = Record<PropertyKey, never>;
export type useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data = {
  readonly entitlements: {
    readonly externalCollaborator: {
      readonly isEntitled: boolean;
    };
  } | null | undefined;
};
export type useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery = {
  response: useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data;
  variables: useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "ExternalCollaboratorFeature",
        "kind": "LinkedField",
        "name": "externalCollaborator",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEntitled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "624bb7f2e1333a1dc93bb4e3e1ab1a47",
    "id": "50cdeb2f8746825d9a317b38ba0c85a01e96c5247af9f0eb632d2a708fb4be48",
    "metadata": {},
    "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
    "operationKind": "query",
    "text": "query useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
  }
};
})();

(node as any).hash = "15c75f072c1c9beaecdb4e535cfc9037";

export default node;
